var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-default",attrs:{"target":"_blank","href":_vm.filePath}},[_c('span',{staticClass:"fas fa-file"}),_vm._v(" "+_vm._s(_vm.file.displayName)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }